<template>
  <v-app>
    <div class="black-screen-none"></div>
    <v-main>
      <AppBar/>
      <router-view />
      <Footer/>
    </v-main>
  </v-app>
</template>

<script>
 import AppBar from "@/components/AppBar.vue"
 import Footer from "@/components/Footer.vue"
export default {
  name: "App",
  components:{AppBar,Footer}
};
</script>
<style>
body,
html {
  padding: 0;
  margin: 0;
  -webkit-text-size-adjust: none;
}
.black-screen{
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 9999;
  background: black;
}
@media (max-width: 450px) {
  .black-screen{
    display: none;
  }
}
</style>
